import { Application } from "@hotwired/stimulus";
import $ from "jquery";
import "./custom_turbo_actions";

window.$ = $;
window.jQuery = $;

const application = Application.start();

// application.debug = true
window.Stimulus = application;

export { application };
